import { render, staticRenderFns } from "./Flyer.vue?vue&type=template&id=3779ccfe&scoped=true"
import script from "./Flyer.vue?vue&type=script&lang=js"
export * from "./Flyer.vue?vue&type=script&lang=js"
import style0 from "./Flyer.vue?vue&type=style&index=0&id=3779ccfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3779ccfe",
  null
  
)

export default component.exports